import React from 'react'
import PropTypes from 'prop-types'
import {
  GoalWarningBanner,
  GoalWarningLink,
  StyledGoalWarningIcon,
} from '../component.styles'
import {
  GOAL_NOT_SET_ADD_GOAL_LINK_TEXT,
  GOAL_NOT_SET_WARNING_PREFIX,
} from '../constants'

const GoalNotSetWarning = ({ onOpenGoalsModal }) => (
  <GoalWarningBanner data-testid="goal-not-set-warning">
    <StyledGoalWarningIcon />
    <span>
      {GOAL_NOT_SET_WARNING_PREFIX}{' '}
      <GoalWarningLink
        data-testid="goal-not-set-add-goal-link"
        onClick={onOpenGoalsModal}
        type="button"
      >
        {GOAL_NOT_SET_ADD_GOAL_LINK_TEXT}
      </GoalWarningLink>
    </span>
  </GoalWarningBanner>
)

GoalNotSetWarning.propTypes = {
  onOpenGoalsModal: PropTypes.func,
}

export default GoalNotSetWarning
